import { forwardRef, type Ref } from 'react';

import classNames from 'classnames';

import { Button } from '@debijenkorf/button';
import { Container, HorizontalStack } from '@debijenkorf/layout';

import styles from './InternalLinks.module.scss';

import { type InternalLink } from '@/services/mappers/common/internalLinksMapper';

type InternaLinkProps = {
  links: InternalLink[];
  title?: string;
  size?: 'large';
  onClick?: (title: string, href: string) => void;
};

export const InternalLinks = forwardRef(
  ({ links, title, size, onClick }: InternaLinkProps, ref: Ref<Element>) => {
    return (
      <Container
        styleExtend={{
          Container: classNames(styles.Wrapper, {
            [styles.WrapperLarge]: size === 'large',
          }),
        }}
        ref={ref}
      >
        {title ? <h3 className={styles.Title}>{title}</h3> : null}
        <HorizontalStack
          gap={16}
          as="ul"
          shouldWrap
          styleExtend={{
            Flex: styles.Links,
          }}
        >
          {links.map(({ title, href }) => {
            if (!title || !href) return null;

            return (
              <li key={title}>
                <Button
                  as="a"
                  href={href}
                  variant="secondary"
                  onClick={() => onClick?.(title, href)}
                >
                  {title}
                </Button>
              </li>
            );
          })}
        </HorizontalStack>
      </Container>
    );
  },
);
